const credential = '';

const voice_config = [
  {
    "id": 1,
    "name": "Skylar",
    "service": "azure",
    "credentials": credential,
    "service_voice_id": "en-US-AriaNeural"
  },
  {
    "id": 2,
    "name": "Ashley",
    "service": "azure",
    "credentials": credential,
    "service_voice_id": "en-US-AshleyNeural",
  },
  {
    "id": 3,
    "name": "Emma",
    "service": "azure",
    "credentials": credential,
    "service_voice_id": "en-US-EmmaMultilingualNeural",
  },
  {
    "id": 4,
    "name": "Nova",
    "service": "azure",
    "credentials": credential,
    "service_voice_id": "en-US-NovaTurboMultilingualNeural",
  },
  {
    "id": 5,
    "name": "Andrew",
    "service": "azure",
    "credentials": credential,
    "service_voice_id": "en-US-AndrewNeural",
  },
  {
    "id": 6,
    "name": "Davis",
    "service": "azure",
    "credentials": credential,
    "service_voice_id": "en-US-DavisMultilingualNeural",
  }

];

const Voices = {};

voice_config.forEach( v => {
	Voices[v.id] = v;
});

module.exports = Voices;
